// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file notification-center.proto (package NotificationCenter, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GraphSyncRef } from "./graph-sync_pb";
import { file_graph_sync } from "./graph-sync_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file notification-center.proto.
 */
export const file_notification_center: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
    [file_graph_sync],
  );

/**
 * @generated from message NotificationCenter.EncryptedData
 */
export type EncryptedData = Message<"NotificationCenter.EncryptedData"> & {
  /**
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message NotificationCenter.EncryptedData.
 * Use `create(EncryptedDataSchema)` to create a new message.
 */
export const EncryptedDataSchema: GenMessage<EncryptedData> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 0);

/**
 * @generated from message NotificationCenter.Notification
 */
export type Notification = Message<"NotificationCenter.Notification"> & {
  /**
   * @generated from field: NotificationCenter.NotificationType type = 1;
   */
  type: NotificationType;

  /**
   * @generated from field: NotificationCenter.NotificationCategory category = 2;
   */
  category: NotificationCategory;

  /**
   * @generated from field: GraphSync.GraphSyncRef sender = 3;
   */
  sender?: GraphSyncRef;

  /**
   * @generated from field: string senderFullName = 4;
   */
  senderFullName: string;

  /**
   * @generated from field: NotificationCenter.EncryptedData encryptedData = 5;
   */
  encryptedData?: EncryptedData;

  /**
   * @generated from field: repeated GraphSync.GraphSyncRef refs = 6;
   */
  refs: GraphSyncRef[];

  /**
   * @generated from field: repeated NotificationCenter.NotificationCategory categories = 7;
   */
  categories: NotificationCategory[];
};

/**
 * Describes the message NotificationCenter.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 1);

/**
 * @generated from message NotificationCenter.NotificationReadMark
 */
export type NotificationReadMark = Message<"NotificationCenter.NotificationReadMark"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: int64 notification_edge_id = 2;
   */
  notificationEdgeId: bigint;

  /**
   * @generated from field: int64 mark_edge_id = 3;
   */
  markEdgeId: bigint;

  /**
   * @generated from field: NotificationCenter.NotificationReadStatus readStatus = 4;
   */
  readStatus: NotificationReadStatus;
};

/**
 * Describes the message NotificationCenter.NotificationReadMark.
 * Use `create(NotificationReadMarkSchema)` to create a new message.
 */
export const NotificationReadMarkSchema: GenMessage<NotificationReadMark> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 2);

/**
 * @generated from message NotificationCenter.NotificationContent
 */
export type NotificationContent = Message<"NotificationCenter.NotificationContent"> & {
  /**
   * @generated from oneof NotificationCenter.NotificationContent.type
   */
  type:
    | {
        /**
         * @generated from field: NotificationCenter.Notification notification = 1;
         */
        value: Notification;
        case: "notification";
      }
    | {
        /**
         * @generated from field: NotificationCenter.NotificationReadStatus readStatus = 2;
         */
        value: NotificationReadStatus;
        case: "readStatus";
      }
    | {
        /**
         * @generated from field: NotificationCenter.NotificationApprovalStatus approvalStatus = 3;
         */
        value: NotificationApprovalStatus;
        case: "approvalStatus";
      }
    | {
        /**
         * @generated from field: bool trimmingPoint = 4;
         */
        value: boolean;
        case: "trimmingPoint";
      }
    | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated int32 clientTypeIDs = 5;
   */
  clientTypeIDs: number[];

  /**
   * @generated from field: repeated int64 deviceIDs = 6;
   */
  deviceIDs: bigint[];
};

/**
 * Describes the message NotificationCenter.NotificationContent.
 * Use `create(NotificationContentSchema)` to create a new message.
 */
export const NotificationContentSchema: GenMessage<NotificationContent> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 3);

/**
 * @generated from message NotificationCenter.NotificationWrapper
 */
export type NotificationWrapper = Message<"NotificationCenter.NotificationWrapper"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: NotificationCenter.NotificationContent content = 2;
   */
  content?: NotificationContent;

  /**
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;
};

/**
 * Describes the message NotificationCenter.NotificationWrapper.
 * Use `create(NotificationWrapperSchema)` to create a new message.
 */
export const NotificationWrapperSchema: GenMessage<NotificationWrapper> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 4);

/**
 * @generated from message NotificationCenter.NotificationSync
 */
export type NotificationSync = Message<"NotificationCenter.NotificationSync"> & {
  /**
   * @generated from field: repeated NotificationCenter.NotificationWrapper data = 1;
   */
  data: NotificationWrapper[];

  /**
   * @generated from field: int64 syncPoint = 2;
   */
  syncPoint: bigint;

  /**
   * @generated from field: bool hasMore = 3;
   */
  hasMore: boolean;
};

/**
 * Describes the message NotificationCenter.NotificationSync.
 * Use `create(NotificationSyncSchema)` to create a new message.
 */
export const NotificationSyncSchema: GenMessage<NotificationSync> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 5);

/**
 * @generated from message NotificationCenter.ReadStatusUpdate
 */
export type ReadStatusUpdate = Message<"NotificationCenter.ReadStatusUpdate"> & {
  /**
   * @generated from field: bytes notificationUid = 1;
   */
  notificationUid: Uint8Array;

  /**
   * @generated from field: NotificationCenter.NotificationReadStatus status = 2;
   */
  status: NotificationReadStatus;
};

/**
 * Describes the message NotificationCenter.ReadStatusUpdate.
 * Use `create(ReadStatusUpdateSchema)` to create a new message.
 */
export const ReadStatusUpdateSchema: GenMessage<ReadStatusUpdate> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 6);

/**
 * @generated from message NotificationCenter.ApprovalStatusUpdate
 */
export type ApprovalStatusUpdate = Message<"NotificationCenter.ApprovalStatusUpdate"> & {
  /**
   * @generated from field: bytes notificationUid = 1;
   */
  notificationUid: Uint8Array;

  /**
   * @generated from field: NotificationCenter.NotificationApprovalStatus status = 2;
   */
  status: NotificationApprovalStatus;
};

/**
 * Describes the message NotificationCenter.ApprovalStatusUpdate.
 * Use `create(ApprovalStatusUpdateSchema)` to create a new message.
 */
export const ApprovalStatusUpdateSchema: GenMessage<ApprovalStatusUpdate> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 7);

/**
 * @generated from message NotificationCenter.ProcessMarkReadEventsRequest
 */
export type ProcessMarkReadEventsRequest =
  Message<"NotificationCenter.ProcessMarkReadEventsRequest"> & {
    /**
     * @generated from field: repeated NotificationCenter.ReadStatusUpdate readStatusUpdate = 1;
     */
    readStatusUpdate: ReadStatusUpdate[];
  };

/**
 * Describes the message NotificationCenter.ProcessMarkReadEventsRequest.
 * Use `create(ProcessMarkReadEventsRequestSchema)` to create a new message.
 */
export const ProcessMarkReadEventsRequestSchema: GenMessage<ProcessMarkReadEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 8);

/**
 * @generated from message NotificationCenter.NotificationSendRequest
 */
export type NotificationSendRequest = Message<"NotificationCenter.NotificationSendRequest"> & {
  /**
   * @generated from field: repeated GraphSync.GraphSyncRef recipients = 1;
   */
  recipients: GraphSyncRef[];

  /**
   * @generated from field: NotificationCenter.Notification notification = 2;
   */
  notification?: Notification;

  /**
   * @generated from field: repeated int32 clientTypeIDs = 3;
   */
  clientTypeIDs: number[];

  /**
   * @generated from field: repeated int64 deviceIDs = 4;
   */
  deviceIDs: bigint[];
};

/**
 * Describes the message NotificationCenter.NotificationSendRequest.
 * Use `create(NotificationSendRequestSchema)` to create a new message.
 */
export const NotificationSendRequestSchema: GenMessage<NotificationSendRequest> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 9);

/**
 * @generated from message NotificationCenter.NotificationsSendRequest
 */
export type NotificationsSendRequest = Message<"NotificationCenter.NotificationsSendRequest"> & {
  /**
   * @generated from field: repeated NotificationCenter.NotificationSendRequest notifications = 1;
   */
  notifications: NotificationSendRequest[];
};

/**
 * Describes the message NotificationCenter.NotificationsSendRequest.
 * Use `create(NotificationsSendRequestSchema)` to create a new message.
 */
export const NotificationsSendRequestSchema: GenMessage<NotificationsSendRequest> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 10);

/**
 * @generated from message NotificationCenter.NotificationSyncRequest
 */
export type NotificationSyncRequest = Message<"NotificationCenter.NotificationSyncRequest"> & {
  /**
   * @generated from field: int64 syncPoint = 1;
   */
  syncPoint: bigint;
};

/**
 * Describes the message NotificationCenter.NotificationSyncRequest.
 * Use `create(NotificationSyncRequestSchema)` to create a new message.
 */
export const NotificationSyncRequestSchema: GenMessage<NotificationSyncRequest> =
  /*@__PURE__*/
  messageDesc(file_notification_center, 11);

/**
 * @generated from enum NotificationCenter.NotificationCategory
 */
export enum NotificationCategory {
  /**
   * @generated from enum value: NC_UNSPECIFIED = 0;
   */
  NC_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NC_ACCOUNT = 1;
   */
  NC_ACCOUNT = 1,

  /**
   * @generated from enum value: NC_SHARING = 2;
   */
  NC_SHARING = 2,

  /**
   * @generated from enum value: NC_ENTERPRISE = 3;
   */
  NC_ENTERPRISE = 3,

  /**
   * @generated from enum value: NC_SECURITY = 4;
   */
  NC_SECURITY = 4,

  /**
   * @generated from enum value: NC_REQUEST = 5;
   */
  NC_REQUEST = 5,

  /**
   * @generated from enum value: NC_SYSTEM = 6;
   */
  NC_SYSTEM = 6,

  /**
   * @generated from enum value: NC_PROMOTION = 7;
   */
  NC_PROMOTION = 7,
}

/**
 * Describes the enum NotificationCenter.NotificationCategory.
 */
export const NotificationCategorySchema: GenEnum<NotificationCategory> =
  /*@__PURE__*/
  enumDesc(file_notification_center, 0);

/**
 * @generated from enum NotificationCenter.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NT_UNSPECIFIED = 0;
   */
  NT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NT_ALERT = 1;
   */
  NT_ALERT = 1,

  /**
   * @generated from enum value: NT_DEVICE_APPROVAL = 2;
   */
  NT_DEVICE_APPROVAL = 2,

  /**
   * @generated from enum value: NT_MASTER_PASS_UPDATED = 3;
   */
  NT_MASTER_PASS_UPDATED = 3,

  /**
   * @generated from enum value: NT_SHARE_APPROVAL = 4;
   */
  NT_SHARE_APPROVAL = 4,

  /**
   * @generated from enum value: NT_SHARE_APPROVAL_APPROVED = 5;
   */
  NT_SHARE_APPROVAL_APPROVED = 5,

  /**
   * @generated from enum value: NT_SHARED = 6;
   */
  NT_SHARED = 6,

  /**
   * @generated from enum value: NT_TRANSFERRED = 7;
   */
  NT_TRANSFERRED = 7,

  /**
   * @generated from enum value: NT_LICENSE_LIMIT_REACHED = 8;
   */
  NT_LICENSE_LIMIT_REACHED = 8,

  /**
   * @generated from enum value: NT_APPROVAL_REQUEST = 9;
   */
  NT_APPROVAL_REQUEST = 9,

  /**
   * @generated from enum value: NT_APPROVED_RESPONSE = 10;
   */
  NT_APPROVED_RESPONSE = 10,

  /**
   * @generated from enum value: NT_DENIED_RESPONSE = 11;
   */
  NT_DENIED_RESPONSE = 11,

  /**
   * @generated from enum value: NT_2FA_CONFIGURED = 12;
   */
  NT_2FA_CONFIGURED = 12,

  /**
   * @generated from enum value: NT_SHARE_APPROVAL_DENIED = 13;
   */
  NT_SHARE_APPROVAL_DENIED = 13,
}

/**
 * Describes the enum NotificationCenter.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> =
  /*@__PURE__*/
  enumDesc(file_notification_center, 1);

/**
 * @generated from enum NotificationCenter.NotificationReadStatus
 */
export enum NotificationReadStatus {
  /**
   * @generated from enum value: NRS_UNSPECIFIED = 0;
   */
  NRS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NRS_LAST = 1;
   */
  NRS_LAST = 1,

  /**
   * @generated from enum value: NRS_READ = 2;
   */
  NRS_READ = 2,

  /**
   * @generated from enum value: NRS_UNREAD = 3;
   */
  NRS_UNREAD = 3,
}

/**
 * Describes the enum NotificationCenter.NotificationReadStatus.
 */
export const NotificationReadStatusSchema: GenEnum<NotificationReadStatus> =
  /*@__PURE__*/
  enumDesc(file_notification_center, 2);

/**
 * @generated from enum NotificationCenter.NotificationApprovalStatus
 */
export enum NotificationApprovalStatus {
  /**
   * @generated from enum value: NAS_UNSPECIFIED = 0;
   */
  NAS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NAS_APPROVED = 1;
   */
  NAS_APPROVED = 1,

  /**
   * @generated from enum value: NAS_DENIED = 2;
   */
  NAS_DENIED = 2,

  /**
   * @generated from enum value: NAS_LOST_APPROVAL_RIGHTS = 3;
   */
  NAS_LOST_APPROVAL_RIGHTS = 3,

  /**
   * @generated from enum value: NAS_LOST_ACCESS = 4;
   */
  NAS_LOST_ACCESS = 4,
}

/**
 * Describes the enum NotificationCenter.NotificationApprovalStatus.
 */
export const NotificationApprovalStatusSchema: GenEnum<NotificationApprovalStatus> =
  /*@__PURE__*/
  enumDesc(file_notification_center, 3);
